export const sizes = ['Small', 'Medium', 'Large', 'X-Large'];
